import { useMemo } from 'react';
import { useI18n } from '../../i18n';
import { translateTodo } from '@cubemeet/core/modules/todo/i18n';

export const useTodoI18n = () => {
  const { language } = useI18n();
  
  const t = useMemo(() => {
    return (key: string, params?: Record<string, any>) => {
      return translateTodo(language, key, params);
    };
  }, [language]);

  return { t, language };
};